const useraffiliate = {
    getlist: 'useraffiliate/getlist-by-admin',
    update: 'useraffiliate/update-by-admin',
    report: 'UserAffiliate/get-report'
}
export default useraffiliate
